import { useEffect, useMemo, useState } from 'react';

import { useHandlePaymentMethod } from '../hooks/useHandlePaymentMethod';

import icCoins from '@/assets/ic_coin.svg';
import bgDesktop from '@/assets/myAccount/bg_only-golden-date--lg@2x.jpg';
import bgMobile from '@/assets/myAccount/bg_only-golden-date--sm@2x.jpg';
import { Button, Modal } from '@/components';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import useTourney from '@/hooks/useTourney';
import InfoContent from '@/modules/tourneys/goldDate/components/InfoContent';
import { TipoProductoTO } from '@/types/myAccount';
import { formatNumberToLocale } from '@/utils/functions';

const ContentDesktop = ({ product }: { product: TipoProductoTO }) => {
  const { handlePaymentMethod } = useHandlePaymentMethod();
  const { isDesktop } = useIsDesktop();
  const { updateTourney } = useTourney();

  if (isDesktop) {
    return (
      <div className="flex flex-1 flex-col pb-5">
        <div className="w-full text-gdt-gray font-medium text-sm text-left relative">
          <ul className="pl-20 space-y-6 pt-10">
            <li className="pl-9">
              <strong className="text-lg">Fecha de Oro</strong>
            </li>
            <li className="flex gap-3">
              <figure>
                <img src={icCoins} width={25} />
              </figure>
              <p>
                Participan sólo 20 DT’s.
                <br /> ¡El ganador se lleva
                <strong>
                  ${' '}
                  {formatNumberToLocale(
                    product.montoPremio || product.precio * 10
                  )}{' '}
                  en efectivo!
                </strong>
              </p>
            </li>
          </ul>
        </div>
        <div className="flex items-center justify-center w-full gap-11 mt-12">
          <Button
            className="font-bold"
            type="button"
            variant="text"
            onClick={() => updateTourney({ showModalInfo: true })}
          >
            Ver más información
          </Button>
          <Button
            className="w-48 font-bold"
            type="button"
            variant="primary"
            onClick={() => handlePaymentMethod({ product })}
          >
            Obtener Pin Especial
          </Button>
        </div>
      </div>
    );
  }
};
export const GoldenCard = ({ product }: { product: TipoProductoTO }) => {
  const { isMobile, isDesktop } = useIsDesktop();
  const [componentIsLoading, setComponentIsLoading] = useState(true);
  const { handlePaymentMethod } = useHandlePaymentMethod();
  const { tourneyData, updateTourney } = useTourney();

  // use fix not loaded content
  useEffect(() => {
    if (componentIsLoading) {
      setComponentIsLoading(false);
    }
  }, [componentIsLoading]);

  const titlePrice1 = (
    <div className="text-left font-bold uppercase lg:absolute lg:bottom-[calc(50%-50px)] lg:left-9 lg:font-bebas lg:flex ">
      <p className="lg:text-3xl text-xs text-gdt-gray-3 lg:text-white lg:font-light">
        pin especial
      </p>
      <span className="lg:text-3xl text-xl text-gdt-gray lg:ml-2 lg:text-white lg:font-light">
        $ {formatNumberToLocale(product.precio)}
      </span>
    </div>
  );

  const titlePrice2 = (
    <div className="text-xl font-light uppercase text-left absolute left-0 h-full flex justify-center flex-col font-bebas text-white px-5 top-3">
      <h3 className="text-3xl font-light">FECHA DE ORO</h3>
      <div className="flex space-x-2 mt-3">
        <p>participás por</p>
        <span>
          $ {formatNumberToLocale(product.montoPremio || product.precio * 10)}
        </span>
      </div>
    </div>
  );

  const contentMobile = useMemo(() => {
    if (isMobile) {
      return (
        <div className="flex px-4 h-[85px] justify-between items-center">
          <div className="flex items-center justify-start gap-2">
            <img src={icCoins} width={34} />
            {titlePrice1}
          </div>
          <Button
            className="w-28 h-9 p-0 text-xs lg:text-base"
            type="button"
            variant="primary"
            onClick={() => handlePaymentMethod({ product })}
          >
            Obtener
          </Button>
        </div>
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);

  return (
    <>
      {!componentIsLoading && (
        <div className=" bg-white text-center lg:mt-7 mt-4 max-w-xl lg:max-w-[985px] w-full mx-auto lg:flex rounded-[11px] lg:h-[263px] relative">
          <figure className="relative">
            <img
              alt="FECHA DE ORO"
              className="imgTagResponsive w-full lg:max-w-[446px] rounded-tl-[5px] lg:rounded-tl-[8px] rounded-tr-[5px] lg:rounded-bl-[7px] lg:rounded-tr-none"
              decoding="async"
              loading="lazy"
              src={isMobile ? bgMobile : bgDesktop}
            />
            {isMobile ? titlePrice2 : titlePrice1}
          </figure>
          {isMobile && !isDesktop ? (
            contentMobile
          ) : (
            <ContentDesktop product={product} />
          )}
        </div>
      )}
      <Modal
        className="w-[600px] text-center px-[38px]"
        controlledOnClose={() => {
          updateTourney({ showModalInfo: false });
        }}
        disableBodyScroll={true}
        isControlledOpen={Boolean(tourneyData.showModalInfo)}
        render={() => <InfoContent product={product} />}
        size="sm"
        variant="controlled"
      />
    </>
  );
};
